import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ProsafetyRedirectPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        // Получаем параметр startapp из URL
        const startapp = searchParams.get('WebAppStartParam');

        // Карта соответствия startapp → путь в приложении
        const routeMap: Record<string, string> = {
            'lesson-1': '/principles',
            'lesson-2': '/safety-distance',
            'lesson-3': '/hazard-perception',
            // Добавляйте свои варианты
        };

        const target = startapp ? routeMap[startapp] : null;

        if (target) {
            // Перенаправляем с заменой истории, чтобы кнопка "Назад" не возвращала на редирект
            navigate(target, { replace: true });
        } else {
            // Если параметра нет или не найден в карте — идём на главную
            navigate('/', { replace: true });
        }
    }, [navigate, searchParams]);

    // Показываем индикатор загрузки на долю секунды (можно пустой div)
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        }}>
            Перенаправление...
        </div>
    );
};

export default ProsafetyRedirectPage;